// `GET /v1/me` (P5 §3.1). Post-cutover pioneros DB: site_id ahora es text
// hex 24 chars (mongo ObjectId de core.site.id), no BIGINT serializado.
import { z } from 'zod';
import { MarzanoRole, SiteId } from '../primitives.js';
export const SiteRef = z.object({
    id: SiteId,
});
export const MeResponse = z.object({
    /** ObjectId Mongo del user en Pioneros (24 hex). */
    user_id: z.string().regex(/^[0-9a-f]{24}$/i),
    email: z.string().email(),
    /** Set deduplicado, serializado como array. */
    roles: z.array(MarzanoRole),
    /** Mayor privilegio del set. Default UI. */
    active_role: MarzanoRole,
    available_sites: z.array(SiteRef).min(1),
    /** Subset de `available_sites` por id. */
    current_site_id: SiteId,
});
//# sourceMappingURL=me.js.map